import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TutorialComponent } from './tutorial.component';
import { RouterModule } from '@angular/router';
import { TutorialService } from './tutorial.service';

@NgModule({
  declarations: [TutorialComponent],
  imports: [CommonModule, IonicModule, RouterModule],
  providers: [TutorialService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TutorialModule {}
